import { CONT_LENS, IContainerInformation } from "@tedivo/tedivo-bay-grid-pure";
import { TContainerNameFn, TContainersSymbolsConfig } from "@tedivo/tedivo-bay-grid-core";
import { feetToMillimeters, roundDec } from "@tedivo/tedivo-pure-helpers";

import { ForeAftEnum } from "open-vessel-definition";

export function generateSideContSymbols(
  prefixSymbol: string,
  colorUnpaired: string,
  colorPairedFwd: string,
  colorPairedAft: string,
): TContainersSymbolsConfig<IContainerInformation> {
  const PAIRED_OPTS = [0, ForeAftEnum.FWD, ForeAftEnum.AFT];
  const colors = [colorUnpaired, colorPairedFwd, colorPairedAft];

  const nameFn: TContainerNameFn<IContainerInformation> =
    (prefixSymbol, contInfo, paired) => `${prefixSymbol}_${contInfo.size}-${paired}`;

  const config: TContainersSymbolsConfig<IContainerInformation> = {
    prefixSymbol,
    nameFn,
    conts: [],
    pathFn: (lengthInMM: number, heightInMM: number) =>
      `M${-lengthInMM * 0.5},${-heightInMM} h${lengthInMM} v${heightInMM} h-${lengthInMM} z`,
  };

  PAIRED_OPTS.forEach((paired) => {
    CONT_LENS.forEach((len) => {
      config.conts.push({
        name: nameFn(prefixSymbol, { size: len } as IContainerInformation, paired),
        lengthInMM: roundDec(feetToMillimeters(len), 0),
        heightInMM: feetToMillimeters(8.5),
        fillColor: colors[paired],
        strokeColor: colors[paired],
        fillOpacity: 0.25,
        strokeOpacity: 0.66,
        strokeWidth: 2,
        strokeDashLength: 1.5,
        dashInTheMiddle: len >= 40,
      });
    });
  });

  return config;
}
